<div class="modal-header">
    <h4 class="modal-title">Confirm</h4>
</div>
<div class="modal-body">{{ message }}</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-danger"
        (click)="decline()"
    >
        No
    </button>
    <button
        type="button"
        class="btn btn-primary"
        (click)="accept()"
    >
        Yes
    </button>
</div>
